{
  "fr": {
    "ai": {
      "assistant": {
        "all_projects": "Tous les projets",
        "cap": {
          "action": "Démarrer une nouvelle conversation",
          "message": "Vous avez atteint la limite de conversation."
        },
        "empty_state": {
          "subtitle": "Posez-moi n'importe quelle question sur vos clients",
          "title": "Comment puis-je vous aider ?"
        },
        "errors": {
          "budget_reached": "Le budget mensuel de l'assistant IA pour cet espace a été atteint. Contactez un administrateur pour augmenter la limite.",
          "generic": "Une erreur s'est produite. Veuillez réessayer."
        },
        "history": {
          "empty": "Aucune conversation passée",
          "title": "Conversations passées"
        },
        "input": {
          "disclaimer": "Les résultats peuvent être inexacts. Vérifiez toujours les informations importantes.",
          "hint": "Entrée pour envoyer · Maj+Entrée pour nouvelle ligne",
          "placeholder": "Posez une question sur vos clients..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Comment configurer les notifications ?",
          "help_project_settings": "Où trouver les paramètres du projet ?",
          "open_decisions": "Quelles décisions sont encore ouvertes ?",
          "unassigned_units": "Quelles units n'ont pas encore de client ?"
        },
        "support_cta": {
          "action": "Contacter le support",
          "prompt": "Ce n'est pas la réponse que vous cherchiez ?"
        }
      },
      "settings": {
        "budget": {
          "budget_label": "Budget",
          "description": "Plafond mensuel pour l'utilisation de l'IA (phase de test). Recalculé en fonction de la consommation de tokens sur toutes les conversations ce mois-ci.",
          "save": "Enregistrer",
          "title": "Budget mensuel",
          "usage_label": "Utilisé ce mois-ci"
        },
        "description": "Configuration des fonctionnalités IA dans votre espace de travail.",
        "title": "Paramètres IA"
      }
    }
  }
}
